import { ReactElement } from 'react';
import { AxiosResultDefaultError } from '../../../api/request';
import { createFetchContext } from '../../../components/contexts/FetchContextFactory';

import { getFormData } from '../requests';
import { CreateValidationFormData } from '../types';

interface BaseLoaderProps {
  children: ReactElement;
  studyPlanEnrollmentId: string | number;
}

const { FetchProvider, FetchConsumer, useFetch } = createFetchContext<
  { studyPlanEnrollmentId: string | number },
  CreateValidationFormData,
  AxiosResultDefaultError
>();

export function useValidationFormLoader() {
  return useFetch();
}

export const ValidationFormLoaderConsumer = FetchConsumer;

export default function ValidationFormLoader({
  children,
  studyPlanEnrollmentId,
}: BaseLoaderProps) {
  return (
    <FetchProvider
      request={getFormData}
      defaultQuery={{ studyPlanEnrollmentId }}
      fetchImmediately
    >
      {children}
    </FetchProvider>
  );
}
